<template>
  <Slide v-bind:isOpen="isOpen" :burgerIcon="false" :crossIcon="false" disableOutsideClick>
      <a id="assignments" href="#" @click.prevent="navContent('assignments');">
        <span>Assignments</span>
      </a>
      <a id="books" href="#" @click.prevent="navContent('books');">
        <span>Books</span>
      </a>
      <a id="videos" href="#" @click.prevent="navContent('videos');">
        <span>Videos</span>
      </a>
      <a id="interactive" href="#" @click.prevent="navContent('interactive');">
        <span>Interactive</span>
      </a>
      <a id="editors" href="#" @click.prevent="navContent('editors');">
        <span>Editors</span>
      </a>
    </Slide>
</template>
<script>
import { Slide } from 'vue-burger-menu'

export default {
    data: function() {
        return {
            isOpen: false
        };
    },
    components : {
        Slide
    },
    mounted: function () { 
    this.$root.$on('TOGGLE_SIDE', () => { // here you need to use the arrow function
        this.isOpen = !this.isOpen;
    })
  },
  methods : {
    navContent: function(target) {
      this.$router.push({ path: "/browse/" + target });
    }
  }
}
</script>